export const checkIfAdminUser = (userRoles = []) =>
  userRoles.some((role) => role.authority === 'ROLE_ADMIN');

export const verifyUserAccess = (userRoles = [], featureRoles = []) =>
  userRoles.some(({ authority }) => featureRoles.includes(authority));

export const getFirstRoute = (userRoles = [], tabs = []) => {
  const isAdmin = checkIfAdminUser(userRoles);

  const firstTab = tabs.find((tab) => verifyUserAccess(userRoles, tab.roles));

  if (!firstTab) {
    if (isAdmin) return tabs[0].path;

    return '/landing';
  }

  return firstTab.path;
};

export const sortByProperty = (array = [], propertyName = '') =>
  [...array].sort((a, b) => {
    if (a[propertyName] < b[propertyName]) {
      return -1;
    }
    if (a[propertyName] > b[propertyName]) {
      return 1;
    }
    return 0;
  });

export const getEncodedURL = (url, params) => {
  if (!params) {
    return url;
  }

  return Object.keys(params)
    .reduce((newUrl, key) => `${newUrl}${key}=${params[key]}%26`, `${url}%3F`) // ? -> %3F | & -> %26
    .slice(0, -3); // Remove extra %26 (length: 3) added at the last
};

export const getLobLogo = (code) => {
  const STATIC_PRODUCT_TILE_BASE_URL =
    'https://static.airasia.com/design/icons/product-tile/';

  const APP_TILE = `${STATIC_PRODUCT_TILE_BASE_URL}app/`;
  const WEB_TILE = `${STATIC_PRODUCT_TILE_BASE_URL}web/`;

  switch (code) {
    case 'activities':
      return `${APP_TILE}activities_flat.png`;
    case 'beauty':
      return `${APP_TILE}beauty_flat.png`;
    case 'ourfresh':
      return `${APP_TILE}ourfresh_flat.png`;
    case 'health':
      return `${APP_TILE}health.png`;
    case 'deal':
      return `${APP_TILE}deals_flat.png`;
    case 'shop':
      return `${APP_TILE}travelmall.svg`;
    case 'hotel':
      return `${APP_TILE}hotels.svg`;
    case 'food':
      return `${APP_TILE}food.svg`;
    case 'Gift':
      return `${APP_TILE}gifts.png`;
    case 'flight':
    case 'flightota':
    case 'LegacyFlight':
    case 'ExtendedFlightOTA':
      return `${APP_TILE}flight_flat.png`;
    case 'AARide':
    case 'RideDriverTopUp':
    case 'ExtendedAARide':
    case 'SettlementAARide':
    case 'AAXpress':
      return `${WEB_TILE}ride.svg`;
    case 'Snap':
    case 'LegacySNAP':
      return `${APP_TILE}snap.svg`;
    case 'IKHLASFidyah':
    case 'ExtendedIKHLASPackage':
    case 'IKHLASZakat':
    case 'IKHLASPackage':
    case 'IKHLASSadaqah':
    case 'IKHLASAqiqah':
      return `${APP_TILE}ikhlas.png`;
    case 'Insurance':
      return `${APP_TILE}insurance.png`;
    case 'lemonadt':
    default:
      return 'favicon.svg';
  }
};
